import { useHistory } from '@shared/core';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useFriendsRegistryRoutePaths } from '../FriendsRegistry.routes';
import { AFFR_BANNER_INPUT_INPUT_ID, AFFR_BANNER_INPUT_SECTION_ID } from '../FriendsRegistry.constants';
import { useShopStorefrontContext } from '../../Catalog/components/ShopStorefrontProvider';
import { CatalogStorefront } from '@graphql/generated-base';

/**
 * Used to redirect user to /add-from-friends-registry landing page from guest shop banner
 */
export const useRedirectToFriendsRegistry = () => {
  const history = useHistory();
  const { currentStorefront } = useShopStorefrontContext();
  const { friendsRegistryRoutes } = useFriendsRegistryRoutePaths();

  const redirect = (website?: string) => {
    const tartgetUrl = website
      ? {
          pathname: `/${website}/edit/registry${friendsRegistryRoutes.addToFriendsRegistryIndex.path}`,
          search: `?scrollto=${AFFR_BANNER_INPUT_SECTION_ID}&focusto=${AFFR_BANNER_INPUT_INPUT_ID}`,
        }
      : { pathname: currentStorefront === CatalogStorefront.baby ? '/createbabyregistry' : '/createwedding', search: '?scenario=add-from-friends-registry' };
    history.push(tartgetUrl);
  };

  const redirectToFriendsRegistry = useEventCallback((website?: string) => {
    if (website && website !== 'event picker dialog') {
      redirect(website);
    } else {
      redirect();
    }
  });

  return { redirectToFriendsRegistry };
};
